<template>
  <b-modal
    visible
    id="modal"
    title="Вход в систему"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    ok-only
    :ok-disabled="!username || !password"
    ok-title="Войти"
    @ok="submit"
  >
    <b-form>
      <b-form-group label="Имя пользователя:" v-model="username">
        <b-form-input
          type="text"
          required
          placeholder="Введите имя пользователя"
          v-model="username"
          :state="
            this.username.length === 0 ? null : !this.error ? true : false
          "
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Пароль:" label-for="input-2">
        <b-form-input
          type="password"
          v-model="password"
          required
          placeholder="Введите пароль"
          :state="
            this.password.length === 0 ? null : !this.error ? true : false
          "
        ></b-form-input>
      </b-form-group>
    </b-form>
    <span v-if="error" class="text-danger">Не правильно указан имя пользователя или пароль!</span>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      username: "",
      password: "",
      error: false
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions(["login"]),
    async submit(e) {
      e.preventDefault();
      const data = {
        username: this.username,
        password: this.password
      };
      const res = await this.login(data);
      if (!res.success) {
        this.error = true;
      } else {
        this.error = false;
      }
    }
  }
};
</script>
